import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-confirm-issue-change',
    templateUrl: './confirm-issue-change.component.html',
    styleUrls: ['./confirm-issue-change.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmIssueChangeComponent implements OnInit {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  rowData: any = {};
  header: string = 'Confirm';
  message: string = '';
  globalIssue: string = '';
  rowIssue: string = '';

  @Input('row-data')
  set _rowData(rowData: string) {
    try {
      let data = JSON.parse(rowData);
      if (Object.keys(data).length > 0) {
        this.rowData = data;
        this.header = data.header || 'Confirm';
        this.message = data.message || '';
        this.globalIssue = data.globalIssue || '';
        this.rowIssue = data.rowIssue || '';
      }
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  constructor() {}

  ngOnInit(): void {}

  onCancel(): void {
    this.cancel();
  }

  onSaveWithGlobalIssue(): void {
    this.requestGridUpdate.emit('save-global-issue');
  }

  onSaveWithRowIssue(): void {
    this.requestGridUpdate.emit('save-row-issue');
  }

  cancel(): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail: 'cancel',
      bubbles: true
    });
    if (document.querySelector('gtw-confirm-issue-change-ce')) {
      document.querySelector('gtw-confirm-issue-change-ce')?.dispatchEvent(updateEvent);
    }
  }
}
